import React from 'react';
import sendAttachments, { Attachment as SendAttachment } from '../../api/sendAttachments';
import { notification } from 'antd';
import { Attachment } from '../../store/types/prescription';
import { track } from '../../tracking';
import { Patient } from '../../store/types/patient';
import AttachmentModal from '../prescriptionPad/rightPanel/workspace/AttachmentModal';

const AttachmentModalGlobalSearch: React.FC<{
    patient: Patient | undefined;
    isSendAttachment: boolean;
    onVisibleChange: (visible: boolean) => void;
}> = (props) => {
    const { patient, isSendAttachment, onVisibleChange } = props;

    const onSendAttachment = async (attachment: Attachment) => {
        const personal = patient?.personal;

        if (!attachment?.title) {
            notification.error({
                message: 'Title is required',
                duration: 5,
                placement: 'topRight',
            });
            return;
        }

        if (!patient?.id || !personal) {
            notification.error({
                message: 'Patient Not Found',
                duration: 5,
                placement: 'topRight',
            });
            return;
        }
        try {
            const attachments: SendAttachment = {
                post: {
                    type: 'ATTACH',
                    meta: {
                        display: {
                            title: attachment?.title || '',
                            description: attachment?.description,
                            link: attachment?.link,
                            file_type: attachment?.file_type,
                        },
                    },
                },
                share: {
                    type: 'PRIVATE',
                    audience: [
                        {
                            id: patient?.id,
                            profile: {
                                personal: {
                                    name: [personal?.name?.f, personal?.name?.l]
                                        .filter(Boolean)
                                        .join(' '),
                                    phone: personal.phone || { c: '', n: '' },
                                    age: personal?.age,
                                    gender: personal?.gender,
                                    mobile: (personal.phone?.c || '') + (personal.phone?.n || ''),
                                    fn: personal?.name?.f,
                                },
                            },
                        },
                    ],
                },
            };

            const res = await sendAttachments({
                attachments: attachments,
                blockTemplateMaking: attachment.templateId ? true : false,
            });

            if (res.status === 'success') {
                notification.success({
                    message: 'Attachments sent successfully',
                    duration: 5,
                    placement: 'topRight',
                });

                track(
                    attachment?.templateId
                        ? 'TEMPLATE_SEND_SUCCESSFUL'
                        : 'ATTACHMENT_SEND_SUCCESSFUL',
                );
            } else {
                notification.error({
                    message: 'Failed to send Attachments',
                    duration: 5,
                    placement: 'topRight',
                });
                track(
                    attachment?.templateId
                        ? 'TEMPLATE_SEND_UNSUCCESSFUL'
                        : 'ATTACHMENT_SEND_UNSUCCESSFUL',
                );
            }
        } catch (error) {
            notification.error({
                message: 'Failed to send Attachments',
                duration: 5,
                placement: 'topRight',
            });
            track(
                attachment?.templateId
                    ? 'TEMPLATE_SEND_UNSUCCESSFUL'
                    : 'ATTACHMENT_SEND_UNSUCCESSFUL',
            );
        }
    };

    return (
        <AttachmentModal
            patientId={patient?.id}
            isVisible={isSendAttachment}
            onVisibleChange={onVisibleChange}
            onSend={onSendAttachment}
            templateApplyText={'Send'}
            templateApplyIcon={
                <span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        className="w-14 h-16 fill-actionPrimary-hover"
                    >
                        <path d="M133.9 232L65.8 95.9 383.4 232H133.9zm0 48H383.4L65.8 416.1l68-136.1zM44.6 34.6C32.3 29.3 17.9 32.3 8.7 42S-2.6 66.3 3.4 78.3L92.2 256 3.4 433.7c-6 12-3.9 26.5 5.3 36.3s23.5 12.7 35.9 7.5l448-192c11.8-5 19.4-16.6 19.4-29.4s-7.6-24.4-19.4-29.4l-448-192z" />
                    </svg>
                </span>
            }
        />
    );
};

export default AttachmentModalGlobalSearch;
